import { render, staticRenderFns } from "./auth-verify-account.vue?vue&type=template&id=34aaf61e&"
import script from "./auth-verify-account.vue?vue&type=script&lang=ts&"
export * from "./auth-verify-account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports